class MegaNav extends HTMLElement {
  #open = false;

  constructor() {
    super();
    this.open = !this.hasAttribute('hidden');
    this.button = this.querySelector('.mega-nav__close');

    this._onButtonClick = this.onButtonClick.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', this._onButtonClick);
  }
  removeEventListeners() {
    this.button.removeEventListener('click', this._onButtonClick);
  }

  onButtonClick() {
    this.toggle();
  }

  get open() {
    return this.#open;
  }

  set open(value) {
    this.#open = value;

    if (this.#open) {
      this.#openContainer();
    } else {
      this.#closeContainer();
    }
  }

  #openContainer() {
    this.removeAttribute('hidden');
    let evt = new CustomEvent('mega-nav-open', { bubbles: true });
    this.dispatchEvent(evt);
  }

  #closeContainer() {
    this.setAttribute('hidden', '');
    let evt = new CustomEvent('mega-nav-close', { bubbles: true });
    this.dispatchEvent(evt);
  }

  toggle() {
    this.open = !this.open;
  }
}

customElements.define('mega-nav', MegaNav);
